import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AppStateType } from "../";
import { SpectrumPricingValuesType } from "../../utils";

export const initialState: SpectrumPricingValuesType = {
  countries: [],
  bands: [],
  operators: [],
  technologies: [],
  licences: [],
  allocated_bandwidth: [],
  allocated_bandwidth_control: "and",
  price_total_min: 0,
  price_total_max: 10881,
  price_population_min: 0,
  price_population_max: 3461,
  completed_year_min: 2010,
  completed_year_max: 2025,
  ituRegions: [],
};

const spectrumPricing = createSlice({
  name: "spectrumPricing",
  initialState: {
    lastSaved: initialState,
    values: initialState,
    rowsPerPage: 100,
    page: 1,
    sortBy: "country_title",
    sortDesc: false,
    currentView: "search",
  },
  reducers: {
    setRowsPerPage: (state, { payload }: PayloadAction<number>) => {
      state.rowsPerPage = payload;
      state.page = 1;
    },
    setPage: (state, { payload }: PayloadAction<number>) => {
      state.page = payload;
    },
    setValues: (state, { payload }: PayloadAction<SpectrumPricingValuesType>) => {
      state.values = payload;
      state.page = 1;
    },
    setSavedValues: (state, { payload }: PayloadAction<SpectrumPricingValuesType>) => {
      state.lastSaved = payload;
    },
    setSortBy: (state, { payload }: PayloadAction<string>) => {
      if (state.sortBy.valueOf() !== payload) {
        state.sortBy = payload;
        state.sortDesc = false;
        state.page = 1;
      } else {
        state.sortDesc = !state.sortDesc.valueOf();
      }
    },
    setCurrentView: (state, { payload }: PayloadAction<string>) => {
      state.currentView = payload;
    },
  },
});

export const { setRowsPerPage, setPage, setValues, setSortBy, setSavedValues, setCurrentView } = spectrumPricing.actions;

export const selectSpectrumPricingSlice = (state: AppStateType) => state.spectrumPricing;

export default spectrumPricing.reducer;
